import { z } from "zod";

/**
 * Conversation ID - aligned with PhoneE164 canonical identity.
 * Example: +12025551234
 */
export const ConversationIdSchema = z
	.string()
	.regex(
		/^\+[1-9]\d{1,14}$/,
		"Conversation ID must be in E.164 format (e.g., +1234567890)"
	)
	.brand("ConversationId");

export type ConversationId = z.infer<typeof ConversationIdSchema>;

export function createConversationId(value: string): ConversationId {
	return ConversationIdSchema.parse(value);
}

export function isConversationId(value: unknown): value is ConversationId {
	return ConversationIdSchema.safeParse(value).success;
}
